import React from "react";
import styled from "styled-components";

interface UnitLabelProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isDisabled?: boolean;
}

export const InputWrapper = styled.div.attrs({
  className: "rounded",
})`
  display: flex;
  width: 100%;
  height: 40px;
`;

export const Input = styled.input.attrs({
  className: "appearance-none focus:outline-none px-4",
  type: "text", // programmatically set type to 'number'?
})`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  width: 70%;
  border: 1px solid #ece6ee;
  ::placeholder {
    color: lightgray;
    font-weight: 100;
  }
`;

export const UnitLabel = styled.select.attrs((props) => ({
  className: "text-sm px-5 appearance-none",
  disabled: props.disabled,
}))<UnitLabelProps>`
  background-color: var(--gray100);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
`;
